import { APIConfig } from "./api.config.interface";

export default (): APIConfig => ({
    url: process.env.REACT_APP_DOCUMENT_PORTAL_API ?? '',
});

